<script lang="ts">
	import { Router, Route } from "svelte-routing";
  import Dashboard from './Dashboard.svelte';
  import CreateSession from './SessionForm.svelte';
  import { isAuthenticated, login } from '../../stores/auth';
import { clearNotif, notifyError } from "../../stores/notifications";

  export let url = "";

  let password = '';

  const tryLogin = () => {
    clearNotif();
    if (password === 'CA2018atoutjeux') {
      login({ name: 'admin-atoutjeux' });
    }
    else {
      notifyError('Mot de passe incorrect.');
    }
  };
</script>

{#if $isAuthenticated}
  <Router {url}>
    <Route path="create-session"><CreateSession /></Route>
    <Route path="/"><Dashboard /></Route>
  </Router>
{:else}

<p>Cette page est réservée aux administrateurs.</p>

<form on:submit|preventDefault={() => tryLogin()}>
<div class="columns is-centered mt-4">
  <div class="column is-two-thirds-tablet">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label for="name">Mot de passe</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="password" bind:value={password} />
          </div>
        </div>
      </div>
    </div>

    <button class="button is-primary" type="submit">Valider</button>
  </div>
</div>
</form>

{/if}


